import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;    // "customer" or "date"
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;        // YYYY-MM-DD
  customer_from?: string;
  customer_to?: string;
}

export interface ReportRow {
  FC120_12: string;      // customer code
  customer_name: string;
  FC120_DATE: string;    // delivery date
  FC120_NO: string;      // delivery no
  FC120_SEQ: number;     // detail seq
  FC120_ITEM: string;    // item code + name
  FC120_CURR: string;    // currency
  FC120_UNIT: string;    // unit
  FC120_PRICE: number;   // price
  FC120_QTY: number;     // qty
  FC120_AMT: number;     // amount
  FC120_NET: number;     // net amount
  FC120_TAX: number;     // tax amount
  FC120_TAMT: number;    // total amount
  FC120_COL: string;     // color code
  FC120_COLN: string;    // color name
  FC131_16: number;      // allowance qty
  FC131_AMT: number;     // allowance amount
}

export interface CurrencySummary {
  group_key: string;     // customer code or date
  currency: string;
  goods_amt: number;
  tax_amt: number;
  total_amt: number;
}

export interface GroupCount {
  code: string;
  name: string;
  count: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  currency_summary: CurrencySummary[];
  group_counts: GroupCount[];
  message?: string;
}

export const c324Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/c324/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/c324/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
